import { useAppSelector } from "@/app_redux/hooks/root_hook";
interface CongratulationsCardData {
  bookings: number;
  orders: number;
  revenue: number;
}
interface CongratulationsCardProps {
  metaData: CongratulationsCardData | null;
}
const CongratulationsCard: React.FC<CongratulationsCardProps> = ({ metaData }) => {
  const { mappedClinicName } = useAppSelector((state) => state.root.UIStates);

  return (
    <div className="relative flex flex-col items-center justify-center text-center bg-white pb-12">
      {/* Background concentric circles */}
      <div className="absolute inset-0 flex items-center justify-center -z-10">
        <div className="w-[500px] h-[500px] rounded-full border border-gray-400 absolute"></div>
        <div className="w-[350px] h-[350px] rounded-full border border-gray-400 absolute"></div>
        <div className="w-[200px] h-[200px] rounded-full border border-gray-400 absolute"></div>
      </div>

      {/* Green badge */}
      <div className="w-36 h-auto relative z-10">
        <img
          src="https://vetic-img.s3.ap-south-1.amazonaws.com/quick_commerce//misc/b393b7b017221c396e9e37ccce8e136c1b39ba2b.gif"
          alt="Badge"
        />
      </div>

      <h2 className="font-semibold text-base -mt-8 z-10">Congratulations</h2>
      <p className="text-gray-600 text-xs mt-2 max-w-md z-10">
        <span className="block">
          Today {mappedClinicName} did{" "}
          <span className="text-blue-600 cursor-pointer">{metaData?.bookings} Appointments</span>,{" "}
        </span>
        <span className="text-red-500 cursor-pointer pt-1 ">Fulfilled {metaData?.orders} Orders</span> & did a{" "}
        <span className="text-green-600 font-medium">Revenue of {metaData?.revenue}</span>
      </p>
    </div>
  );
};

export default CongratulationsCard;
